module.exports = __webpack_public_path__ + "media/images/landing_page/2023/webpage/majaslapa-preview-5d2521f8f658277adede9885544be48a.webp";